import { GiHamburgerMenu } from "react-icons/gi";
import { IoCreateOutline } from "react-icons/io5";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Toggle from "../ThemeToggle";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseURL, logoutUser } from "../../redux/Action";
import { useDispatch } from "react-redux";

const Navbar = () => {
  const [isAuth, setIsAuth] = useState(true);
  const [user, setUser] = useState({});
  const [show, setShow] = useState(false);
  const [showham, setShowham] = useState(false);
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("User")) || {};
  const auth = localStorage.getItem("isAuth") || false;

  useEffect(() => {
    setIsAuth(auth);
    setUser(userDetails);
  }, [auth]);

  const navigate = useNavigate();
  const logout = () => {
    axios
      .get(`${baseURL}/logout`, {
        withCredentials: true,
      })
      .then((res) => {
        setIsAuth(false);
        setShow(false);
        logoutUser(dispatch);
        navigate("/");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const modalContent1 = document.getElementById("modalContent");
      const modalContent2 = document.getElementById("modalContent2");

      if (modalContent1 && !modalContent1.contains(event.target)) {
        setShowham(false);
      }

      if (modalContent2 && !modalContent2.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowham, setShow]);

  return (
    <header className="text-gray-600 dark:text-white body-font sticky z-[1000] top-0 px-10 bg-white dark:bg-[#0a0a0d] border-b border-gray-400">
      <div className="flex justify-between sm:px-[2rem] py-4 items-center">
        <div className="relative">
          <span
            className="text-2xl cursor-pointer"
            onClick={() => setShowham(!showham)}
          >
            <GiHamburgerMenu />
          </span>
          {showham && (
            <>
              <div
                id="modalContent"
                className="origin-top-right absolute left-0 mt-2 w-[10rem] rounded-md shadow-xl border dark:border-none py-1 bg-white dark:bg-[#1d1e2b] ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
                tabIndex="-1"
              >
                <Link
                  to="/blogs"
                  onClick={() => setShowham(false)}
                  className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
                  role="menuitem"
                  tabIndex="-1"
                  id="user-menu-item-0"
                >
                  Blogs
                </Link>
                {!isAuth && (
                  <>
                    <Link
                      to="/login"
                      onClick={() => setShowham(false)}
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
                      role="menuitem"
                      tabIndex="-1"
                      id="user-menu-item-0"
                    >
                      Login
                    </Link>
                    <Link
                      to="/signup"
                      onClick={() => setShowham(false)}
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
                      role="menuitem"
                      tabIndex="-1"
                      id="user-menu-item-0"
                    >
                      Create Account
                    </Link>
                  </>
                )}
                {isAuth && (
                  <>
                    <Link
                      to="/blogs/trash"
                      onClick={() => setShowham(false)}
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
                      role="menuitem"
                      tabIndex="-1"
                      id="user-menu-item-0"
                    >
                      Blogs in trash
                    </Link>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        <NavLink
          to={"/"}
          className="flex title-font font-bold items-center text-gray-900"
        >
          <span className="ml-3 text-xl tracking-widest dark:text-white uppercase">
            Blogshog
          </span>
        </NavLink>

        <div className="flex gap-2 sm:gap-4">
          <Toggle />
          {isAuth && (
            <>
              <div className="relative">
                <div>
                  <button
                    type="button"
                    className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white outline-none border-none"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    onClick={() => {
                      setShow(!show);
                      setIsAuth(true);
                    }}
                  >
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-10 w-10 rounded-full"
                      src={user?.user?.avatar}
                      alt="avatar"
                    />
                  </button>
                </div>
                {show && (
                  <>
                    <div
                      id="modalContent2"
                      className="origin-top-right absolute right-[-2rem] mt-2 w-32 sm:w-48 rounded-md shadow-lg py-1 bg-white dark:bg-[#1d1e2b] ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="user-menu-button"
                      tabIndex="-1"
                    >
                      <NavLink
                        to="/blogs/create"
                        onClick={() => setShow(false)}
                        className="w-[7rem] gap-1 justify-center items-center cursor-pointer  py-1 flex sm:hidden"
                      >
                        <span className="text-xl">
                          <IoCreateOutline />
                        </span>
                        create
                      </NavLink>
                      <Link
                        to="/profile"
                        onClick={() => setShow(false)}
                        className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
                        role="menuitem"
                        tabIndex="-1"
                        id="user-menu-item-0"
                      >
                        Your Profile
                      </Link>
                      <p
                        className="block px-4 py-2 text-sm cursor-pointer text-gray-700 dark:text-white"
                        role="menuitem"
                        tabIndex="-1"
                        id="user-menu-item-2"
                        onClick={logout}
                      >
                        Sign out
                      </p>
                    </div>
                  </>
                )}
              </div>
              <NavLink
                to="/blogs/create"
                className="w-[7rem] gap-1 justify-center items-center cursor-pointer border-[.08rem] border-gray-400 rounded-md py-1 hidden sm:flex"
              >
                <span className="text-xl">
                  <IoCreateOutline />
                </span>
                create
              </NavLink>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
